<template>
  <div>
    <section>
      <section-title :title="$t('message.attribute')"/>
      <div class="col-md-12 no-padding">
        <div class="row">
          <template v-for="(item, index) in data.length">
            <div class="wrap-attributes-input col-md-12">
              <div class="form-row mb-2">
                <div class="col-4">
                  <div class="form-group row">
                    <div class="col-md-12 inner-attribute-name">
                      <input
                        :placeholder="$t('message.attributename')"
                        v-model="data[index].name"
                        :disabled="disabled"
                        type="text"
                        class="form-control form-control-sm"
                        style="border-radius: .25rem 0 0 .25rem;"
                        @click="inputClick(index)"
                        @keyup="autoInsertOptions(data[index].name, index)">
                    </div>
                  </div>
                </div>
                <div class="col-8">
                  <div
                    :class="[{'disabled': data[index].name == ''}]"
                    class="form-group row inner-option-name">
                    <div
                      class="col-md-12"
                      style="position: relative;">
                      <div
                        v-if="data[index].name == ''"
                        class="overlay-disable"/>
                      <input-tags
                        :placeholder="$t('message.options_colorsize')"
                        :options="optionsAttributes"
                        :default="data[index].name !== '' ? inputTagOptions[index] : []"
                        :disabled="disabled"
                        v-model="data[index].options"/>
                    </div>
                    <button
                      v-if="data.length > 1 && !disabled && data[index].name != ''"
                      class="btn-delete"
                      @click="del(index)">
                      <i class="far fa-trash-alt"/>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </section>

    <section class="mb-1">
      <section-title :title="$t('message.function')"/>
      <div class="col-md-12 no-padding">
        <div class="form-row">
          <div class="col-md-12 col-lg-6">
            <div class="form-group row mb-2">
              <div class="col-md-12">
                <vs-checkbox
                  v-model="checkCopyPrice"
                  :disabled="disabled"
                  color="#A3CA76"
                  style="float: left;margin: 0;">{{ $t('message.replaceprice') }}</vs-checkbox>
              </div>
            </div>
            <div class="form-group row mb-2">
              <div class="col-md-12">
                <vs-checkbox
                  v-model="checkCopyCost"
                  :disabled="disabled"
                  color="#A3CA76"
                  style="float: left;margin: 0;">{{ $t('message.replacecost') }}</vs-checkbox>
              </div>
            </div>
          </div>
          <div
            v-if="!isFoundCustomSku(prices) || page == 'new'"
            class="col-md-12 col-lg-6">
            <div class="form-group row mb-2">
              <div class="col-md-12">
                <vs-checkbox
                  v-model="checkGenSku"
                  :disabled="disabled"
                  color="#A3CA76"
                  style="float: left;margin: 0;">{{ $t('message.autogensku') }}</vs-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="prices.length > 0"
      class="wrapper-prices mb-0">
      <section-title :title="$t('apps.pos.message.prices', {number: prices.length})"/>
      <div
        v-for="(data, index) in prices"
        :key="index"
        class="item col-md-12 no-padding mb-3">
        <div
          class="col-md-12"
          style="background: #F5F5F5;padding: 10px 10px 0 10px;">
          <div
            class="row"
            style="margin-bottom: 8px;">
            <div class="col-6">
              <span
                v-for="(attribute, _index) in data.attributes"
                :key="_index"
                style="margin-right: 10px;">{{ attribute.name }}: {{ attribute.option }}</span>
            </div>
            <div
              class="col-6 text-right"
              style="max-height: 24px;position: relative;right: -9px;">
              {{ $t('message.available') }}
              <vs-switch
                v-model="prices[index].is_available"
                :disabled="disabled"
                color="#A3CA76"
                style="float: right;position: relative;margin-right: 10px;margin-left: 10px;"/>
            </div>
          </div>
          <div class="form-row">
            <div class="col-lg-6">
              <div class="input-group mb-10px">
                <div class="input-group-prepend">
                  <button
                    :disabled="disabled"
                    class="btn dropdown-toggle min-width-label text-left"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style="border: 1px solid #ced4da;">
                    <template v-if="data.is_fixedprice">
                      {{ $t('message.fixedprice') }}
                    </template>
                    <template v-if="!data.is_fixedprice">
                      {{ $t('message.variableprice') }}
                    </template>
                  </button>
                  <div class="dropdown-menu">
                    <a
                      class="dropdown-item"
                      @click="data.is_fixedprice = true;prices[index].price = setToCustomDigitsNumber(0)">{{ $t('message.fixedprice') }}</a>
                    <a
                      class="dropdown-item"
                      @click="data.is_fixedprice = false;prices[index].price = null">{{ $t('message.variableprice') }}</a>
                  </div>
                </div>
                <input
                  :disabled="!data.is_fixedprice || disabled"
                  v-model="prices[index].price"
                  type="text"
                  class="form-control form-control-sm text-right text-select-all"
                  @keypress="numberOnly"
                  @keyup="prices[index].price = setToValidNumber(prices[index].price); keyupPricce(prices[index].price);"
                  @blur="prices[index].price = setToCustomDigitsNumber(prices[index].price); setAllNumberToDigits();">
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input-group mb-10px">
                <div class="input-group-prepend">
                  <span class="input-group-text min-width-label">{{ $t('message.cost') }}</span>
                </div>
                <input
                  v-model="prices[index].cost"
                  :disabled="disabled"
                  type="text"
                  class="form-control form-control-sm text-right text-select-all"
                  @keypress="numberOnly"
                  @keyup="prices[index].cost = setToValidNumber(prices[index].cost); keyupCost(prices[index].cost);"
                  @blur="prices[index].cost = setToCustomDigitsNumber(prices[index].cost); setAllNumberToDigits();">
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-lg-6">
              <div class="input-group mb-10px">
                <div class="input-group-prepend">
                  <span class="input-group-text min-width-label">{{ $t('message.barcode') }}</span>
                </div>
                <input
                  v-model="prices[index].barcode"
                  :disabled="disabled"
                  type="text"
                  class="form-control form-control-sm text-right">
              </div>
            </div>
            <div class="col-lg-12">
              <div class="form-row">
                <div class="col-lg-6">
                  <div class="input-group mb-10px">
                    <div class="input-group-prepend">
                      <span class="input-group-text min-width-label">{{ $t('message.sku') }}</span>
                    </div>
                    <input
                      :class="[{'is-invalid': foundSkuCode(prices[index].sku)}]"
                      :disabled="disabled"
                      v-model="prices[index].sku"
                      type="text"
                      class="form-control form-control-sm text-right border-radius-right"
                      @keyup="prices[index].is_custom_sku = true">
                    <div class="invalid-feedback text-right">
                      {{ $t('placeholder.unique') }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="page === 'new'"
                  class="col-lg-6">
                  <div class="input-group mb-10px">
                    <div class="input-group-prepend">
                      <span class="input-group-text min-width-label">{{ $t('message.stockcount') }}</span>
                    </div>
                    <input
                      v-model="prices[index].stock_count"
                      type="text"
                      class="form-control form-control-sm text-right text-select-all border-radius-right"
                      @keypress="numberOnly"
                      @keyup="prices[index].stock_count = setToValidNumber(prices[index].stock_count);"
                      @blur="prices[index].stock_count = prices[index].stock_count > 0 ? setToCustomDigitsNumber(prices[index].stock_count) : null">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  props: {
    data: {
      type: Array,
    },
    defaultPrices: {
      type: Array,
    },
    validation: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    trickReset: {
      type: Number,
      default: 0,
    },
    page: {
      type: String,
    },
  },
  data () {
    return {
      prices: [],
      checkGenSku: false,
      checkCopyPrice: false,
      checkCopyCost: false,

      optionsAttributes: [],

      inputTagOptions: [null, null, null],
    }
  },
  computed: {
    ...mapGetters({
      nextSkucode: 'getNextSkuCode',
      allSkuCode: 'getAllSkuCode',
      allSkuAttributes: 'getAllSkuAttributes',
      getUIOptions: 'getUIOptions',
    }),
    isValid () {
      /*
       *  validation
       */
      // if(this.filterData().length == 0) {
      //   return false
      // }

      for (let i in this.prices) {
        let price = this.prices[i]
        if (price.sku) {
          if (this.foundSkuCode(price.sku)) {
            return false
          }
        }
      }

      return true
    },
  },
  methods: {
    ...mapActions([
      'updateUIOptions',
    ]),
    inputClick (index) {
      let isLast = index == this.data.length - 1
      if (isLast) {
        this.add()
      }
    },
    add () {
      if (this.data.length < 3) {
        this.data.push({
          name: '',
          options: [],
        })
      }
    },
    del (index) {
      var that = this

      // remove data at index
      that.data.splice(index, 1)

      // temp data
      var temp = that.getObject(that.data)

      // clear
      that.reset({ add: false })

      // add data from temp
      setTimeout(() => {
        for (let i in temp) {
          that.data.push(temp[i])
        }
      }, 1)
    },
    keyupName () {

    },
    keyupOption (index) {

    },
    genPrices (attributes) {
      var prices = []
      var pattern = []
      var count = 1
      var maxIdx = []
      var currentPattern = []
      var currentIdx = []
      var rootAtIdx = attributes.length - 1
      var enable = true

      function getAttr (pattern) {
        var results = []
        for (let i in attributes) {
          results.push({
            name: attributes[i].name,
            option: attributes[i].options[pattern[i]],
          })
        }
        return results
      }

      for (let i in attributes) {
        let optsCount = attributes[i].options.length
        count *= optsCount
        maxIdx.push(optsCount - 1)
        currentPattern.push(0)
        currentIdx.push(0)
      }

      for (var i = 0; i < count; i++) {
        var arr = []
        for (let attrIdx in attributes) {
          attrIdx = parseInt(attrIdx)
          arr.push(currentIdx[attrIdx])
        }

        pattern[i] = arr

        currentIdx[attributes.length - 1]++

        if (currentIdx[attributes.length - 1] > maxIdx[attributes.length - 1]) {
          currentIdx[attributes.length - 1] = 0

          if (enable) {
            enable = false
            rootAtIdx--
          }

          if (currentIdx[rootAtIdx] !== undefined) {
            if (currentIdx[rootAtIdx] < maxIdx[rootAtIdx]) {
              currentIdx[rootAtIdx]++
            } else {
              currentIdx[rootAtIdx] = 0
              currentIdx[0]++
            }
          }
        }
      }
      for (var i = 0; i < count; i++) {
        prices.push({
          'attributes': getAttr(pattern[i]),
          'pcode': null,
          'sku': null,
          'stock_count': null,
          'barcode': null,
          'price': this.setToCustomDigitsNumber(0),
          'cost': null,
          'is_available': true,
          'is_fixedprice': true,
          'is_custom_sku': false,
        })
      }

      return prices
    },
    getPrices (newPrices, oldPrices) {
      function getPriceByItem (item, prices) {
        var result = null
        prices.find(price => {
          var _item = ''
          price.attributes.find(attribute => {
            _item += attribute.name + '' + attribute.option
          })
          if (item == _item) {
            result = _.cloneDeep(price)
          }
        })
        return result
      }

      let temp_oldPrices = _.cloneDeep(oldPrices)

      var resultPrices = []
      var newAttrInArray = []
      var oldAttrInArray = []

      newPrices.map(price => {
        var item = ''
        price.attributes.map(attribute => {
          item += attribute.name + '' + attribute.option
        })
        newAttrInArray.push(item)
      })
      oldPrices.map(price => {
        var item = ''
        price.attributes.map(attribute => {
          item += attribute.name + '' + attribute.option
        })
        oldAttrInArray.push(item)
      })

      newPrices.map(price => {
        var item = ''
        var result = null
        price.attributes.map((attribute, index) => {
          item += attribute.name + '' + attribute.option
        })
        if (oldAttrInArray.indexOf(item) >= 0) {
          result = getPriceByItem(item, oldPrices)
        } else {
          result = getPriceByItem(item, newPrices)
        }
        if (result) {
          resultPrices.push(result)
        }
      })

      return resultPrices
    },
    keyupPricce (price) {
      if (this.checkCopyPrice) {
        for (let i in this.prices) {
          if (this.prices[i].is_fixedprice) {
            this.prices[i].price = price
          } else {
            this.prices[i].price = null
          }
        }
      }
    },
    keyupCost (cost) {
      if (this.checkCopyCost) {
        for (let i in this.prices) {
          this.prices[i].cost = cost
        }
      }
    },
    genSkuCode () {
      let front = this.nextSkucode
      var that = this
      setTimeout(() => {
        that.prices.map((price, index) => {
          if (!price.is_custom_sku) {
            let number = parseInt(index) + 1
            let last = that.pad(number, 2)
            price.sku = front + '-' + last
          }
        })
      }, 100)
    },
    filterData () {
      var filterData = []
      for (let i in this.data) {
        let item = this.data[i]
        if (item.name.trim().length > 0 && item.options.length > 0) {
          filterData.push(item)
        }
      }
      return filterData
    },
    reset (opt = {}) {
      let that = this
      this.data.length = 0
      that.prices = []
      setTimeout(() => {
        if (opt.add) {
          that.add()
        }
      }, 1)
    },
    foundSkuCode (sku_code) {
      var cloneData = _.cloneDeep(this.allSkuCode)

      if (this.defaultPrices) {
        let tempSkucode = _.cloneDeep(cloneData)
        let mySkucode = []
        this.defaultPrices.map(price => {
          if (price.sku != null) {
            mySkucode.push(price.sku)
          }
        })
        cloneData = []
        tempSkucode.map(val => {
          if (mySkucode.indexOf(val) == -1) {
            cloneData.push(val)
          }
        })
      }

      this.prices.map(price => {
        if (price.sku) {
          cloneData.push(price.sku)
        }
      })

      var done = false
      cloneData.map((val, index) => {
        if (!done && val == sku_code) {
          done = true
          cloneData.splice(index, 1)
        }
      })

      if (cloneData.indexOf(sku_code) >= 0) {
        return true
      }

      return false
    },
    updateUIOptionsState () {
      // set ui options
      this.updateUIOptions({
        'status': {
          'newproduct': {
            'auto_gen_sku': this.checkGenSku,
            'auto_copy_price': this.checkCopyPrice,
            'auto_copy_cost': this.checkCopyCost,
          },
        },
      })
    },
    autoInsertOptions (attr_name, optIndex) {
      let attributes = this.allSkuAttributes

      var notFound = true

      attributes.map(attr => {
        if (attr.name == attr_name && notFound) {
          this.inputTagOptions[optIndex] = attr.options
          notFound = false
        }
      })

      if (notFound) {
        this.inputTagOptions[optIndex] = null
      }

      let temp = this.data[optIndex].name
      this.data[optIndex].name += ' '
      this.data[optIndex].name = temp
    },
    isFoundCustomSku (prices) {
      var foundSku = false
      prices.map(price => {
        if (price.sku !== null) {
          foundSku = true
        }
      })
      return !!foundSku
    },
    setAllNumberToDigits () {
      for (let i in this.prices) {
        if (this.prices[i].is_fixedprice) {
          this.prices[i].price = this.setToCustomDigitsNumber(this.prices[i].price)
        } else {
          this.prices[i].price = null
        }
        if (this.prices[i].cost) {
          this.prices[i].cost = this.setToCustomDigitsNumber(this.prices[i].cost)
        }
      }
    },
  },
  watch: {
    validation () {
      var filterData = this.filterData()
      var data = []
      var isValid = false
      if (this.isValid) {
        if (filterData.length > 0) {
          data = this.prices
        }
        isValid = true
      }
      this.$emit('data', isValid, data)
    },
    checkGenSku: function (newVal, oldVal) {
      if (newVal == false) {
        for (let i in this.prices) {
          this.prices[i].sku = null
        }
      } else {
        this.genSkuCode()
      }
      // update update ui state
      if (this.page == 'new') {
        this.updateUIOptionsState()
      }
    },
    checkCopyPrice: function (newVal, oldVal) {
      if (newVal == true) {
        if (this.prices.length > 0) {
          let firstOne = this.prices[0].price
          this.prices.map((price, index) => {
            this.prices[index].price = firstOne
          })
        }
      }
      // update update ui state
      if (this.page == 'new') {
        this.updateUIOptionsState()
      }
    },
    checkCopyCost: function (newVal, oldVal) {
      if (newVal == true) {
        if (this.prices.length > 0) {
          let firstOne = this.prices[0].cost
          this.prices.map((price, index) => {
            this.prices[index].cost = firstOne
          })
        }
      }
      // update update ui state
      if (this.page == 'new') {
        this.updateUIOptionsState()
      }
    },
    data: {
      handler: function () {
        // filter data before call genPrices function
        let filterData = this.filterData()
        // set prices
        let oldPrices = _.cloneDeep(this.prices)
        let newPrices = _.cloneDeep(this.genPrices(filterData))

        if (filterData.length > 0) {
          this.prices = this.getPrices(newPrices, oldPrices)
        } else {
          this.prices = []
        }
      },
      deep: true,
    },
    prices: {
      handler: function () {
        // check gen sku
        if (this.checkGenSku) {
          if (!this.isFoundCustomSku(this.prices) || this.page == 'new') {
            this.genSkuCode()
          }
        }
      },
      deep: true,
    },
    trickReset () {
      this.reset({ add: true })
    },
  },
  created: function () {
    // set check value
    if (this.page == 'new') {
      if (this.getUIOptions.status) {
        if (this.getUIOptions.status.newproduct) {
          this.checkGenSku = this.getUIOptions.status.newproduct.auto_gen_sku
          this.checkCopyPrice = this.getUIOptions.status.newproduct.auto_copy_price
          this.checkCopyCost = this.getUIOptions.status.newproduct.auto_copy_cost
        }
      }
    }
    // set optionsAttributes
    if (this.allSkuAttributes != null) {
      this.allSkuAttributes.map(attr => {
        attr.options.map(option => {
          this.optionsAttributes.push({
            'item': option,
          })
        })
      })
    }
  },
  mounted: function () {
    if (!this.disabled) {
      if (this.filterData().length == 0 && this.data.length == 0 || this.page == 'edit') {
        this.add()
      }
    }

    if (this.defaultPrices) {
      let that = this
      let __ = _
      setTimeout(() => {
        that.prices = __.cloneDeep(this.defaultPrices)
      }, 10)
    }
  },
}
</script>

<style scoped>
  .wrap-attributes-input .form-group {
    margin-bottom: 4px;
  }
  .wrap-attributes-input .form-group:last-of-type {
    margin-bottom: 0;
  }
  .wrap-attributes-input .inner-attribute-name {
    padding-right: 2px;
    z-index: 2;
  }
  .wrap-attributes-input .inner-option-name {
    position: relative;
  }
  .wrap-attributes-input .inner-option-name .btn-delete {
    position: absolute;
    z-index: 2;
    top: -1px;
    right: 16px;
    color: #BBBBBB;
    background: none;
    border: none;
    padding: 7px 10px 5px 10px;
    outline: none;
  }
  .wrap-attributes-input:last-of-type .form-row {
    margin-bottom: 0 !important;
  }
  .wrapper-prices .item:last-of-type {
    margin-bottom: 0 !important;
  }
  .overlay-disable {
    position: absolute;
    top: 0;
    left: 17px;
    width: -webkit-calc(100% - 31px);
    width:    -moz-calc(100% - 31px);
    width:         calc(100% - 31px);
    height: 100%;
    opacity: 0;
    z-index: 3;
  }
  .min-width-label {
    min-width: 100px;
  }
  .border-radius-right {
    border-radius: 0 .2rem .2rem 0 !important;
  }
</style>

<style>
  .inner-option-name.disabled .selectize-input {
    background: #e9ecef !important;
  }
  .inner-option-name.disabled .selectize-control.multi .selectize-input > div{
    background: rgba(203,203,203, .4) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom/Attribute.vue